import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import TopExportCSV from "../../../../componentsTopsa/exportCSV/TopExportCSV";
import acc from 'accounting'
import DystansKMFilter from "./DystansKMFilter";

export default class UrzadRaportPoLiniachTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            wszystkieKolumnyEksport: [
                {value: "nr_linii", label: 'Nr linii'},
                {value: "trasa", label: 'Trasa'},
                {value: "odcinek_trasy", label: 'Odcinek trasy'},
                {value: "km", label: 'Dystans w kilometrach'},
                {value: "nazwa_ulgi", label: 'Nazwa ulgi'},
                {value: "grupa_ulg", label: 'Nr grupy ulgi'},
                {value: "proc_ulgi", label: 'Procent ulgi'},
                {value: "typ_biletu", label: 'Typ biletu'},
                {value: "ilosc", label: 'Ilość'},
                {value: "wart_bil_brutto", label: 'Wartość biletu brutto'},
                {value: "wart_bil_netto", label: 'Wartość biletu netto'},
                {value: "wart_bil_vat", label: 'Wartość biletu vat'},
                {value: "wart_dopl_brutto", label: 'Wartość dopłaty brutto'},
                {value: "wart_dopl_netto", label: 'Wartość dopłaty netto'},
            ],
            kolumnyDoExportuDefault: [
                {value: "nr_linii", label: 'Nr linii'},
                {value: "trasa", label: 'Trasa'},
                {value: "odcinek_trasy", label: 'Odcinek trasy'},
                {value: "km", label: 'Dystans w kilometrach'},
                {value: "nazwa_ulgi", label: 'Nazwa ulgi'},
                {value: "grupa_ulg", label: 'Nr grupy ulgi'},
                {value: "proc_ulgi", label: 'Procent ulgi'},
                {value: "typ_biletu", label: 'Typ biletu'},
                {value: "ilosc", label: 'Ilość'},
                {value: "wart_bil_brutto", label: 'Wartość biletu brutto'},
                {value: "wart_bil_netto", label: 'Wartość biletu netto'},
                {value: "wart_bil_vat", label: 'Wartość biletu vat'},
                {value: "wart_dopl_brutto", label: 'Wartość dopłaty brutto'},
                {value: "wart_dopl_netto", label: 'Wartość dopłaty netto'},
            ],
        };

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextprops) {
    }

    formatCena(cell, row) {
        return acc.formatMoney(cell)
    }

    formatOdcinek(cell,row){
        return(<div style={{fontSize:'12px'}}>
            <div><i className={'fa fa-sign-in'}></i> {row.naz_pr_od}</div>
            <div><i className={'fa fa-sign-out'}></i> {row.naz_pr_do}</div>
        </div>)
    }

    formatLinia(cell,row){
        return(<div style={{fontSize:'12px', lineHeight:'1.7em'}}>
            <span className={'label label-ebus-primary'}>{row.id_li}</span> {cell}
        </div>)
    }

    getDystansFilter(filterHandler, customFilterParameters) {
        return (
            <DystansKMFilter filterHandler={filterHandler}/>
        );
    }
    
    render() {
        const options = {
            noDataText: 'Brak pasujących rekordów',
        };

        const typy = {
            'JEDNORAZOWY': 'JEDNORAZOWY',
            'MIESIECZNY': 'MIESIĘCZNY'
        }

        return (
            <div>
                <div>
                    <TopExportCSV daneRest={this.props.data} wszystkieKolumny={this.state.wszystkieKolumnyEksport}
                                  kolumnyDoExportu={this.state.kolumnyDoExportuDefault}/>
                </div>
                <div>
                    <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                        Ilość wyszukanych rekordów: {Boolean(this.props.data) ? this.props.data.length : 0}
                    </div>
                </div>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    hover
                    >
                        <TableHeaderColumn dataField='nr_linii' isKey dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                        >Linia nr</TableHeaderColumn>
                        <TableHeaderColumn dataField='trasa' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                        >Trasa</TableHeaderColumn>
                        <TableHeaderColumn dataField='odcinek_trasy' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                        >Odcinek</TableHeaderColumn>
                        <TableHeaderColumn dataField='km' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'CustomFilter', getElement: this.getDystansFilter}}
                        >Dystans [km]</TableHeaderColumn>
                        <TableHeaderColumn dataField='grupa_ulg' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           dataFormat={(cell,row)=>{return(<div style={{fontSize:'12px'}}>{cell}</div>)}}
                        >Nr grupy ulgi</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazwa_ulgi' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={(cell,row)=>{return(<div style={{fontSize:'12px'}}>{cell}</div>)}}
                        >Nazwa ulgi</TableHeaderColumn>
                        <TableHeaderColumn dataField='proc_ulgi' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                        >Procent ulgi</TableHeaderColumn>
                        <TableHeaderColumn dataField='typ_biletu' dataSort
                                           expandable={false}
                                           filter={{type: 'SelectFilter', options: typy, selectText: '', condition: 'like'}}
                                           formatExtraData={typy}
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           dataFormat={(cell, row) => {
                                               return <span style={{fontSize: '12px'}}>{cell.substr(0, 4) + '.'}</span>
                                           }}
                        >Typ</TableHeaderColumn>
                        <TableHeaderColumn dataField='ilosc' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                        >Ilość</TableHeaderColumn>
                        <TableHeaderColumn dataField='wart_bil_brutto' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Wart. biletu brutto</TableHeaderColumn>
                        <TableHeaderColumn dataField='wart_bil_netto' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Wart. biletu netto</TableHeaderColumn>
                        <TableHeaderColumn dataField='wart_bil_vat'
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Wart. biletu VAT</TableHeaderColumn>
                        <TableHeaderColumn dataField='wart_dopl_brutto' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Wart. dopłaty brutto</TableHeaderColumn>
                        <TableHeaderColumn dataField='wart_dopl_netto' dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.formatCena}
                        >Wart. dopłaty netto</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/raport_sprzedazy_po_liniach/components/UrzadRaportPoLiniachTable.js